import React from 'react'
import { reduxForm } from 'redux-form'
import { validation, SubmitButton, Form, Field } from '../helpers/form'

const validateUserEmail = [validation.required, validation.validateEmail]
const validateAccountPassword = [validation.required]

const SigninForm = ({ handleSubmit, submitting, classes, pending }) => (
  <Form onSubmit={handleSubmit}>
    <Field
      label="E-mail address"
      name="email"
      type="text"
      validate={validateUserEmail}
      disabled={pending}
    />
    <Field
      label="Account password"
      name="password"
      type="password"
      validate={validateAccountPassword}
      disabled={pending}
    />
    <SubmitButton
      disabled={pending || submitting}
      text={pending ? 'Signing in…' : 'Sign in'}
    />
  </Form>
)

export default reduxForm({ form: 'signin' })(SigninForm)



// WEBPACK FOOTER //
// ./src/components/SigninForm.js